<button
  mat-stroked-button
  color="primary"
  style="max-width: 36px; min-width: 36px; flex: 1; background-color: white; height: 32px"
  (click)="addToCalendar(); $event.stopImmediatePropagation()"
  matTooltip="Download event to your calendar"
>
  <mat-icon color="primary">download</mat-icon>
</button>
